// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__RyM1x","loaderBox":"loader_loaderBox__VtAN2","loader":"loader_loader__L-KSV"};